(() => {
  const storageKey = 'tis-celebration-saved-v1';
  const validDesign = (item) => {
    if (!item || typeof item.handle !== 'string' || typeof item.title !== 'string' || typeof item.url !== 'string') return false;
    try { const url = new URL(item.url, location.origin); return url.origin === location.origin && /\/products\/[a-z0-9-]+$/.test(url.pathname); } catch { return false; }
  };
  const readSaved = () => {
    try { const items = JSON.parse(localStorage.getItem(storageKey) || '[]'); return Array.isArray(items) ? items.filter(validDesign).slice(0, 100) : []; } catch { return []; }
  };
  let saved = readSaved();
  const announce = (message) => { const status = document.querySelector('[data-cs-status]'); if (status) status.textContent = message; };
  const renderSaved = () => {
    document.querySelectorAll('[data-cs-save]').forEach((button) => {
      const selected = saved.some((item) => item.handle === button.dataset.csSave);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? 'Unsave' : 'Save'} ${button.dataset.csTitle}`);
    });
    document.querySelectorAll('[data-cs-saved-count]').forEach((count) => { count.textContent = String(saved.length); count.hidden = !saved.length; });
    const list = document.querySelector('[data-cs-saved-list]');
    if (list) {
      list.replaceChildren();
      saved.forEach((item) => {
        const row = document.createElement('div'); row.className = 'cs-saved-row';
        const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'cs-icon'; remove.dataset.csRemove = item.handle; remove.innerHTML = '<svg class="tis-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>'; remove.setAttribute('aria-label', `Remove ${item.title} from saved designs`);
        row.append(link, remove); list.append(row);
      });
    }
    const empty = document.querySelector('[data-cs-saved-empty]'); if (empty) empty.hidden = saved.length > 0;
  };
  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); return true; } catch { return false; }
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cs-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.csOpen);
      if (!dialog || dialog.open) return;
      renderSaved(); dialog.showModal();
      dialog.addEventListener('close', () => { if (open.isConnected) open.focus(); }, { once: true });
      return;
    }
    const close = event.target.closest('[data-cs-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const save = event.target.closest('[data-cs-save]');
    const remove = event.target.closest('[data-cs-remove]');
    if (!save && !remove) return;
    const handle = save?.dataset.csSave || remove.dataset.csRemove;
    const index = saved.findIndex((item) => item.handle === handle);
    if (index >= 0) saved.splice(index, 1);
    else if (save) {
      const item = { handle, title: save.dataset.csTitle, url: save.dataset.csUrl };
      if (!validDesign(item)) return;
      if (saved.length >= 100) { announce('Your shortlist is full. Remove a saved design to add another.'); return; }
      saved.push(item);
    }
    const persisted = persist(); renderSaved();
    announce(persisted ? (index >= 0 ? 'Design removed from your shortlist.' : 'Design saved to your shortlist.') : 'Shortlist updated for this visit. Browser storage is unavailable.');
    if (remove) (document.querySelector('[data-cs-remove]') || document.querySelector('#CsSaved [data-cs-close]'))?.focus();
  });
  document.addEventListener('tis:catalog:updated', renderSaved);
  window.addEventListener('storage', (event) => { if (event.key === storageKey) { saved = readSaved(); renderSaved(); } });
  renderSaved();
})();
